module.exports = __webpack_public_path__ + "media/images/icon-search-758525ff25ff5efd3a24c6416c29c2d7.svg";